import React from "react";
import { ExpiredTokenBody } from "tsi-common-react/src/apps/customer-account/ExpiredTokenBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ExpiredTokenDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ExpiredTokenBody {...props} />
    </PageSkeleton>
);
